import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { Modal } from '@flipster/react/design-system-legacy/modal';

interface TokenInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  content: ReactNode;
}

const TokenInfoModal = ({ isOpen, onClose, onExit, content }: TokenInfoModalProps) => {
  const t = useTranslations();
  return (
    <Modal isOpen={isOpen} onExit={onExit} css={{ w: 800 }}>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label={t('Autogen_common.r251126.s_About')} />
      </Modal.Header>
      <Modal.Content css={{ '& > p:not(:last-child)': { mb: '1.2em' } }}>{content}</Modal.Content>
    </Modal>
  );
};

export default TokenInfoModal;
